import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  confirmRemoveScale: (shouldRemoveScale: boolean) => void;
  isRemovingBodyScale: boolean;
  t: (key: string) => string;
}

const RemoveBodyScaleComponent: FunctionComponent<IProps> = ({t, confirmRemoveScale, isRemovingBodyScale}) => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.header}>{t('confirmDontHaveScale')}</Text>
      </View>
      <View>
        <Button title={t('removeScale')} fontColor={Theme.WHITE} containerStyle={styles.removeScale}
          onPress={() => confirmRemoveScale(true)}
          isLoading={isRemovingBodyScale}
        />
        <Button
          title={t('noContinueToScan')}
          fontColor={Theme.PRIMARY}
          buttonType={ButtonTypes.OUTLINE}
          onPress={() => confirmRemoveScale(false)}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    marginHorizontal: defaultScale(15),
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  header: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
  },
  removeScale: {
    marginBottom: defaultScale(14),
  },
});

export const RemoveBodyScale = translate(['bodyscan'])(
  RemoveBodyScaleComponent,
);
